import React from 'react';
import { Box } from '@skin-seoul/design-system';
import MobileRecentlyViewedProductCard from './cards/MobileRecentlyViewedProductCard';
const scrollableStyle = {
  scrollSnapType: 'x mandatory',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  scrollbarWidth: 'none'
} as const;
const RecentlyViewedProductsScrollSkeleton = ({
  count = 3
}: {
  count?: number;
} = {}) => {
  return <Box display="flex" overflowX="auto" gap={4} mb={8} py={2} css={scrollableStyle} data-sentry-element="Box" data-sentry-component="RecentlyViewedProductsScrollSkeleton" data-sentry-source-file="RecentlyViewedProductsScroll.skeleton.tsx">
      {Array.from({
      length: count
    }).map((_, index) => <Box key={index} ml={index === 0 ? 'calc(50vw - 152px)' : 0} mr={index === count - 1 ? 'calc(50vw - 152px)' : 0} minWidth="304px" gap={0} scrollSnapAlign="center" display="flex">
          <MobileRecentlyViewedProductCard.Skeleton />
        </Box>)}
    </Box>;
};
export default RecentlyViewedProductsScrollSkeleton;